/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Platforms_Win_DescInputs */

const en_fc_home_platforms_win_desc = /** @type {(inputs: Fc_Home_Platforms_Win_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MSI installers and portable zips for x64, ARM64 and 32-bit PCs running Windows 10 or 11.`)
};

/**
* | output |
* | --- |
* | "MSI installers and portable zips for x64, ARM64 and 32-bit PCs running Windows 10 or 11." |
*
* @param {Fc_Home_Platforms_Win_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_platforms_win_desc = /** @type {((inputs?: Fc_Home_Platforms_Win_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Platforms_Win_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_platforms_win_desc(inputs)
});
export { fc_home_platforms_win_desc as "fc.home.platforms.win.desc" }